import {formatUnits} from 'ethers';
import type {NearTraderQuoteView} from '../../../../packages/sdk/src/near-market-data';

export function NearTraderDetails({quote}:{quote?:NearTraderQuoteView}){
  if(!quote)return <small>Itemized quote details unavailable. Refresh the quote.</small>;
  return <dl aria-label="Reviewed quote details">
    <div><dt>Slippage</dt><dd>{quote.slippageBps/100}%</dd></div>
    <div><dt>Price impact</dt><dd>{quote.priceImpactBps===null?'Unavailable':`${quote.priceImpactBps/100}%`}</dd></div>
    {quote.fees.map((fee,index)=><div key={`${fee.kind}:${index}`}><dt>{fee.kind.replaceAll('_',' ')}</dt>
      <dd>{fee.amount?`${formatUnits(fee.amount.raw,fee.amount.asset.decimals)} ${fee.amount.asset.symbol}`:'Unavailable'} · {fee.basis.replaceAll('_',' ')}</dd></div>)}
    <div><dt>Protected output</dt><dd>{formatUnits(quote.minimumOutput.raw,quote.minimumOutput.asset.decimals)} {quote.minimumOutput.asset.symbol}</dd></div>
  </dl>;
}
